import { adminApi } from "../../lib/axios";

export interface Niche {
  id: string;
  name: string;
  description: string;
  status: "ACTIVE" | "INACTIVE";
  createdAt: string;
  updatedAt: string;
  nicheId: string | null;
  brandCount?: number;
  affiliateCount?: number;
}

export interface NicheBrand {
  id: string;
  name: string;
  email: string;
}

export interface NicheAffiliate {
  id: string;
  name: string;
  email: string;
}

export interface CreateNicheInput {
  name: string;
  description: string;
}

export interface UpdateNicheInput {
  name?: string;
  description?: string;
  status?: "ACTIVE" | "INACTIVE";
}

export const adminNichesService = {
  async getAllNiches(status?: "all" | "enabled"): Promise<Niche[]> {
    const params = status ? { status } : { status: "all" };
    const response = await adminApi.get("/niche", { params });
    return response.data;
  },

  async getNicheById(id: string): Promise<Niche> {
    const response = await adminApi.get(`/niche/${id}`);
    return response.data;
  },

  async createNiche(data: CreateNicheInput): Promise<Niche> {
    const response = await adminApi.post("/niche/create", data);
    return response.data;
  },

  async updateNiche(id: string, data: UpdateNicheInput): Promise<Niche> {
    const response = await adminApi.patch(`/niche/${id}`, data);
    return response.data;
  },

  async deleteNiche(id: string): Promise<void> {
    await adminApi.delete(`/niche/${id}`);
  },

  async getNicheBrands(id: string): Promise<NicheBrand[]> {
    const response = await adminApi.get(`/niche/${id}/brands`);
    return response.data;
  },

  async getNicheAffiliates(id: string): Promise<NicheAffiliate[]> {
    const response = await adminApi.get(`/niche/${id}/affiliates`);
    return response.data;
  },
};

